import React from 'react'

import VideoPlayer from '../../components/video-player'

const Default = () => {
	return (
		<VideoPlayer />
	)
}

export default Default


// WEBPACK FOOTER //
// ./src/mobile/pages/watch/default.js